var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.imageSrc)?_c('img',{staticClass:"file-thumbnail",style:(_vm.thumbnailStyles),attrs:{"src":_vm.imageSrc,"alt":_vm.fileName}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }